export default __webpack_public_path__ + "./assets/background-pure-desktop__4541e42acaac1a3267e0e94c6a466e57.jpg";